import { render, staticRenderFns } from "./Especies.vue?vue&type=template&id=76f0fb0d"
import script from "./Especies.vue?vue&type=script&lang=js"
export * from "./Especies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports